module.exports = require("npm:core-util-is@1.0.2/lib/util.js");